import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { SERVER_DATE_FORMAT, DEFAULT_DATE_FORMAT } from 'constants/mainConstants';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const getCurrentTimezone = () => {
  return `${dayjs.tz.guess().split('/')[1]} (${dayjs().offsetName()})`;
};

export const convertDateToServerStrFormat = (dateStr: string | null) => {
  try {
    const resultStr = (typeof dateStr === 'string' && !!dateStr.trim())
      ? dayjs(dateStr, DEFAULT_DATE_FORMAT).format(SERVER_DATE_FORMAT)
      : null;

    return resultStr;
  } catch {
    return dateStr;
  }
};
